import React from "react";
import axios2 from 'services/axios2';

import {useParams} from "react-router-dom";
import {Link,hashHistory} from 'react-router-dom';
import { ToastContainer, toast } from 'react-toastify';
import NuDropdown from "../../../components/nubox/NuDropdown";
import ImageUploadSingle from "components/nubox/ImageUploadSingle";

//import listac from '../assets/img/lista2.png';

import {
  Table,
  Button,
  Container,
  Modal,
  ModalHeader,
  ModalBody,
  FormGroup,
  ModalFooter,
  ToastHeader,
} from "reactstrap";

//type:'numeric'

const cbo=[
  {  value:'1', label: 'label1'},  
]

const formInitial = {
  idd:0,
  ope:'n',
  id_mate:0,
  sigla:'',
  nombre:'',
  id_grupo:0, 
  id_nivel:1,     
  pre_requisito:'',
  color1:'',
};
//$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$$
class ModalMateria extends React.Component {
  state = {
    modalInsertar:false,
    form: formInitial,
    
    grupos:[], /* combo grupos */
    carreras:[],
    niveles:[],
  };
  
  //------------------------------------------------------
  componentDidMount() {
    console.log("componentDidMount Modal");
    //--limpiamos el array de prueba
        
    this.cargar_grupos();
    this.cargar_carreras();
    this.cargar_niveles();
   
    //---------
    this.limpiar();
  }

  limpiar = () =>{
    //this.setState({form: formInitial});
    /*this.setState({form:{...this.state.form, 
            sigla:'',
            nombre:'',
          }});*/
  }
  //----------------especial, actualiza valores del form -------------------------------
  handleChangeForm = (e) => {
    //requerimos la prop name="?" en cada control
    this.setState({
      form: {
        ...this.state.form,
        [e.target.name]: e.target.value,
      },
    });
  };
  //----cargamos los datos desde la base de datos
  cargar_grupos = async() => {
    let param = { }
    await axios2.post("cbo_grupos", param).then(res => {
        if(res.data.length>0){ 
            this.setState({grupos: res.data});
            //------actualizamos el form
            console.log( res.data[0].value)
            this.setState({form:{...this.state.form, id_grupo: res.data[0].value}});
        }else{
          toast.error("No existen datos");
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
  cargar_carreras = async() => {
    let param = { }
    await axios2.post("cbo_carrera", param).then(res => {
        if(res.data.length>0){ 
            this.setState({carreras: res.data});
            //------actualizamos el form
            this.setState({form:{...this.state.form, id_carre: res.data[0].value}});
        }else{
          toast.error("No existen datos");
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
  //======================================================
  cargar_niveles = async() => {
    let param = { }
    await axios2.post("cbo_nivel", param).then(res => {
        if(res.data.length>0){ 
            this.setState({niveles: res.data});
            //------actualizamos el form
            this.setState({form:{...this.state.form, id_nivel: res.data[0].value}});
        }else{
          toast.error("No existen datos");
        }
    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  };
  //======================================================
  showModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: true});
  }
  closeModal = () => {
    //setModalOpen(true);
    this.setState({ modalInsertar: false});
  }
  
  //---------------
  nuevo =() =>{
    console.log('nuevo');
    //this.limpiar();
    
    this.setState({
      form: {
        ...this.state.form, //
        id: 0,
        ope:'n',
        sigla:'',
        nombre:'',
      },
      modalInsertar: true,
    });
  }
  //---------------
  editar =(idd)=>{
    console.log('editar');
    let param = { 
      idd: idd,
      ope:'f'
    }
    
    axios2.post( "materia_store", param).then(res => {
      console.log(res.data);

        if(res.data !== null){ 
            //NotificationManager.success("Correcto");
            
            //---asignamos los valores
            this.setState({
              form: {
                ...res.data,
                "idd": idd,
                "ope": 'e',
              },
              modalInsertar: true, /* show modal */
            });

            //----
        }else{
          toast.error("No existen datos");
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  }

  eliminar =(idd)=>{
    console.log("eliminar");
    let param = { 
      idd: idd,
      ope:'x'
    }
    //console.log(param);
    axios2.post(process.env.REACT_APP_API_URL  + "materia_store", param).then(res => {
      console.log(res.data);

        if(res.data.exito===1){ 
            //NotificationManager.success("Correcto");
            this.limpiar();
            this.closeModal();
            toast.success("Eliminado con exito");
            this.props.okModal(); //callback
        }else{
          toast.error("Error al eliminar registro", {
            position: toast.POSITION.TOP_RIGHT
          });
        }

    }).catch(error => {
        alert("---- Existio un error ---");
        console.log(error);
        
    });
  }

  validar = () =>{
    if( this.state.form.id_espe===0){
      toast.error( "Especialidad no valido", {position: toast.POSITION.TOP_RIGHT});
      return true;
    }
  }
  //-------------------------------------
  formSave = () => {
    // the item selected
    console.log("save");

    let error = this.validar();
    if(error===true){
      return;
    }
    
    
    let param = this.state.form;
    console.log(param);

    axios2.post("materia_store", param).then(res => {
        let response = res.data;
    

        if(response.exito===1){ 
            
          toast.success( response.men, {position: toast.POSITION.TOP_RIGHT});
          //---llamamos a la funcion externa
          this.props.okModal();
          this.closeModal();
        }else{

          toast.error( response.men, {position: toast.POSITION.TOP_RIGHT});
        }

    }).catch(error => {
        //if(error.response.status && error.response.status===400)
        alert("Bad Request");
        console.log(error);
        
    });

  }
  
  render() {
    
    return (
      <div>
        
        
        {/*--- modal---- size="sm" */}
        <Modal isOpen={this.state.modalInsertar} toggle={this.closeModal} 
                >
          <ModalHeader toggle={this.closeModal} 
            className= { (this.state.form.ope==='n'? "header-verde":"header-naranja") + " " + (this.state.form.ope==='n'? "color:'#45b545'":"color:'#343b43'")  } 
          >
            <h4 className="modal-title">
            { this.state.form.ope==='n'
              ? "Nuevo"
              : "Editar"
            }
            </h4>
          </ModalHeader>

          <ModalBody style={{background: "#F7F7F7"}}>
            <form  method='POST'>
            {
                //JSON.stringify(this.state.form)
            }
              <div className="row">
                <div className="col-md-6">
                  <div className='form-group row'>  
                    <label htmlFor='id_mate' className='col-md-4 control-label'><b>Cod. </b></label>
                    <div className='col-md-4'>
                        <input 
                          name='id_mate' 
                          type='text' 
                          className='form-control' 
                          value={this.state.form.id_mate} 
                          onChange={ this.handleChangeForm} readOnly />
                    </div>
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-label">Sigla:</label>
                    <input 
                        type="text"
                        name="sigla"
                        value={this.state.form.sigla}
                        onChange={this.handleChangeForm}
                        className="form-control"
                        style={{textTransform: 'uppercase'}}
                        autoComplete="off"
                    />
                  </div>
                </div>
                <div className="col-md-6">
                  <div className="form-group">
                    <label className="control-label">Grupo:
                      <span id=""></span>
                    </label>

                    <NuDropdown
                        options={this.state.grupos}
                        name="id_grupo"
                        value={this.state.form.id_grupo}
                        onChange={this.handleChangeForm}
                    />
                    
                    
                  </div>
                </div>

              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Nombre.:</label> 
                    <input
                      type="text"
                      name="nombre"
                      value={this.state.form.nombre}
                      onChange={this.handleChangeForm}
                      className="form-control"
                      style={{textTransform: 'uppercase'}}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Carrera:
                      
                    </label>

                    <NuDropdown 
                        options={this.state.carreras}
                        
                        name="id_carre"
                        value={this.state.form.id_carre}
                        onChange={this.handleChangeForm}
                    />
                    
                    
                  </div>
                </div>  
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Semestre/año:
                    </label>

                    <NuDropdown 
                        options={this.state.niveles}
                        
                        name="id_nivel"
                        value={this.state.form.id_nivel}
                        onChange={this.handleChangeForm}
                    />
                    
                    
                  </div>
                </div>  
              </div>

              <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Pre Requisito:</label> 
                    <input
                      type="text"
                      name="pre_requisito"
                      value={this.state.form.pre_requisito}
                      onChange={this.handleChangeForm}
                      className="form-control"
                      style={{textTransform: 'uppercase'}}
                      autoComplete="off"
                    />
                  </div>
                </div>
              </div>

               <div className="row">
                <div className="col-md-12">
                  <div className="form-group">
                    <label className="control-label">Color:</label> 
                    
                    
                    <div class="input-group">
                      <input
                        type="text"
                        name="color1"
                        value={this.state.form.color1}
                        onChange={this.handleChangeForm}
                        className="form-control"
                        autoComplete="off"
                      />
                      <span class="input-group-btn">
                        {
                          //<button class="btn btn-default">.00</button>
                        }
                      </span>
                      
                    </div>

                  </div>
                </div>
              </div>


            </form>
          </ModalBody>
          <ModalFooter>
            <Button color="primary" onClick={ this.formSave}>Guardar</Button>{' '}
            <Button color="secondary" onClick={this.closeModal}>Cancel</Button>
          </ModalFooter>
        </Modal>
      </div>
    );
  }
}
  
//------------
export default ModalMateria;